var _mask, _g, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniEstacionamientoResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "97qaa5mdoa",
    width: 23,
    height: 6,
    x: 9,
    y: 11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 11h22.5v5.761H9v-5.76z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#97qaa5mdoa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M30.75 16.761c-.094 0-.189-.018-.282-.055L20.25 12.56l-10.218 4.147c-.387.155-.822-.03-.977-.413-.156-.384.03-.82.413-.977l10.5-4.26c.181-.074.383-.074.564 0l10.5 4.26c.384.156.57.593.413.977-.118.291-.399.468-.695.468z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "pjgmut89zb",
    width: 18,
    height: 15,
    x: 11,
    y: 16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.644 16.887h17.213v14H11.644v-14z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pjgmut89zb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M25.476 27.1c-.832 0-1.508-.675-1.508-1.508 0-.832.675-1.508 1.508-1.508.832 0 1.507.676 1.507 1.508 0 .833-.675 1.508-1.507 1.508zm-10.494 0c-.833 0-1.508-.675-1.508-1.508 0-.832.675-1.508 1.508-1.508.832 0 1.507.676 1.507 1.508 0 .833-.675 1.508-1.507 1.508zm.446-8.674h9.645l1.295 4.069H14.135l1.293-4.07zm1.612-1.54h-2.12c-.306 0-.585.182-.706.465l-1.757 5.144h-.043c-.425 0-.77.345-.77.77v4.654c0 .427.345.77.77.77h.29v1.427c0 .426.344.77.77.77h1.852c.424 0 .77-.344.77-.77v-1.427h8.309v1.427c0 .426.344.77.77.77h1.852c.426 0 .769-.344.769-.77v-1.427h.29c.427 0 .77-.343.77-.77v-4.654c0-.425-.344-.77-.771-.77h-.042l-1.756-5.144c-.122-.282-.4-.464-.707-.464h-8.54z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniEstacionamientoResting);
export default __webpack_public_path__ + "static/media/icon_mini_estacionamiento_resting.02cf61ec6dd8aad12b5a7fc816af4683.svg";
export { ForwardRef as ReactComponent };